var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-pause",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 992C246.90000031 992 32 777.09999969 32 512S246.90000031 32 512 32s480 214.90000031 480 480-214.90000031 480-480 480z m0-79.99999969c220.92 0 400.00000031-179.08000031 400.00000031-400.00000031S732.92 111.99999969 512 111.99999969 111.99999969 291.08 111.99999969 512s179.08000031 400.00000031 400.00000031 400.00000031z m-60-200.00000062h-79.99999969V312.00000031h79.99999969v399.99999938z m199.99999969 0h-79.99999969V312.00000031h79.99999969v399.99999938z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcPause);
export default __webpack_public_path__ + "static/media/rc-pause.1af815c7d943c1b565981cd3833e24eb.svg";
export { ForwardRef as ReactComponent };